import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Icon } from '@sm/wds-react';

import './logo.scss';

const Logo = ({ color, className, ...other }) => {
  const classNames = classnames(`sm-logo--${color}`, className);
  return (
    <Icon className={classNames} {...other}>
      ÷
    </Icon>
  );
};

Logo.propTypes = {
  color: PropTypes.oneOf(['primary', 'alt']),
  className: PropTypes.string
};

Logo.defaultProps = {
  color: 'primary',
  className: ''
};

export default Logo;
